var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#ececec",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#ececec",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon / TikTok"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.3754 4.3862V5.9487C13.3412 5.84488 12.3485 5.47101 11.499 4.85984L10.5486 4.17599V5.34687V10.9368C10.5486 13.3979 8.54607 15.3999 6.08582 15.4C4.90251 15.3983 3.76814 14.9275 2.93131 14.0908C2.09443 13.2541 1.62341 12.1198 1.62148 10.9364C1.62173 8.47631 3.62344 6.47469 6.08326 6.47394C6.11116 6.47407 6.13905 6.47447 6.16693 6.47513V8.0261C6.14017 8.02527 6.11339 8.0248 6.08659 8.02472L6.08504 8.02472C5.514 8.02434 4.95547 8.19194 4.47898 8.50664C4.00248 8.82134 3.62908 9.26925 3.40526 9.79459C3.18144 10.3199 3.11708 10.8995 3.2202 11.4612C3.32333 12.0228 3.58938 12.5417 3.98522 12.9533C4.38107 13.3649 4.88923 13.6509 5.44644 13.7758C6.00365 13.9007 6.58529 13.859 7.11895 13.6558C7.65261 13.4525 8.11471 13.0969 8.44772 12.633C8.78073 12.1691 8.96994 11.6175 8.99179 11.0469L8.99222 11.0355L8.99223 11.0242L8.99677 0.6H10.59C10.6627 1.12788 10.8302 1.64001 11.0862 2.1111C11.4381 2.75874 11.9461 3.30835 12.564 3.71012C13.1124 4.06821 13.7315 4.29812 14.3754 4.3862Z",
    strokeWidth: 1.2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok-icon.f57cbae525395b92f7a57a671c2a836c.svg";
export { ForwardRef as ReactComponent };